const getBorderColor = p => {
  if (p.isPartOfFilter) {
    return p.theme.colors.background;
  }
  return p.isOpen ? p.theme.colors.white : p.theme.colors.secondary.gray;
};

const getBackgroundColor = p => {
  if (p.isPartOfFilter) {
    return p.theme.colors.background;
  }
  return p.isOpen ? p.theme.colors.white : "inherit";
};

const getHoverBorderColor = p => {
  if (p.isPartOfFilter) {
    return p.theme.colors.secondary.stroke;
  }
  return p.theme.colors.secondary.minor;
};

const getHoverBackgroundColor = p => {
  if (p.isPartOfFilter) {
    return p.theme.colors.secondary.stroke;
  }
  p.theme.colors.white;
};

export {
  getBorderColor,
  getBackgroundColor,
  getHoverBorderColor,
  getHoverBackgroundColor,
};
